<div *ngIf="!isTemplateReady" class="container-fluid p-4 skeleton-container">
  <div class="skeleton-line mx-auto mb-4" style="height:24px; max-width:50%;"></div>
  <div class="skeleton-line mb-3" style="max-width:75%;"></div>
  <div class="skeleton-line mb-2"></div>
  <div class="skeleton-line mb-2"></div>
  <div class="skeleton-line mb-4" style="max-width:60%;"></div>
  <div class="row mb-3">
    <div class="col-6"><div class="skeleton-block mb-2" style="height:120px;"></div></div>
    <div class="col-6"><div class="skeleton-block mb-2" style="height:120px;"></div></div>
  </div>
  <div class="skeleton-line mb-3" style="height:20px; max-width:40%;"></div>
  <div class="skeleton-line mb-2"></div>
  <div class="skeleton-line mb-2"></div>
  <div class="skeleton-line mb-2" style="max-width:80%;"></div>
  <div class="skeleton-line mb-2"></div>
  <div class="skeleton-line mb-4" style="max-width:70%;"></div>
  <div class="row">
    <div class="col-6"><div class="skeleton-block" style="height:80px;"></div></div>
    <div class="col-6"><div class="skeleton-block" style="height:80px;"></div></div>
  </div>
</div>

<ng-container *ngIf="isTemplateReady">
<ng-container [ngSwitch]="effectiveTemplateKey">

<!-- Italian Template -->
<ng-container *ngSwitchCase="'amdc_italian'">
  <app-agreement-template-italian
    [entityData]="entityData"
    [studentAccountEntityData]="studentAccountEntityData"
    [studioInformationConfig]="studioInformationConfig"
    [enrollmentForm]="enrollmentForm"
    [isTaxInclusive]="isTaxInclusive"
    [displaySignatures]="displaySignatures"
    [_enrollmentEntityData]="_enrollmentEntityData">
  </app-agreement-template-italian>
</ng-container>

<!-- Quebec Template -->
<ng-container *ngSwitchCase="'amdc_quebec'">
  <app-agreement-template-quebec
    [entityData]="entityData"
    [studentAccountEntityData]="studentAccountEntityData"
    [studioInformationConfig]="studioInformationConfig"
    [enrollmentForm]="enrollmentForm"
    [isTaxInclusive]="isTaxInclusive"
    [displaySignatures]="displaySignatures"
    [displaySigned]="displaySigned"
    [_enrollmentEntityData]="_enrollmentEntityData">
  </app-agreement-template-quebec>
</ng-container>

<!-- British Columbia Template -->
<ng-container *ngSwitchCase="'amdc_bc'">
  <app-agreement-template-bc
    [entityData]="entityData"
    [taxConfig]="taxConfig"
    [studentAccountEntityData]="studentAccountEntityData"
    [studioInformationConfig]="studioInformationConfig"
    [enrollmentForm]="enrollmentForm"
    [isTaxInclusive]="isTaxInclusive"
    [displaySignatures]="displaySignatures"
    [displaySigned]="displaySigned"
    [_enrollmentEntityData]="_enrollmentEntityData">
  </app-agreement-template-bc>
</ng-container>

<!-- Ontario Template -->
<ng-container *ngSwitchCase="'amdc_ontario'">
  <app-agreement-template-ontario
    [entityData]="entityData"
    [taxConfig]="taxConfig"
    [studentAccountEntityData]="studentAccountEntityData"
    [studioInformationConfig]="studioInformationConfig"
    [enrollmentForm]="enrollmentForm"
    [isTaxInclusive]="isTaxInclusive"
    [displaySignatures]="displaySignatures"
    [displaySigned]="displaySigned"
    [_enrollmentEntityData]="_enrollmentEntityData">
  </app-agreement-template-ontario>
</ng-container>

<!-- Alberta Template -->
<ng-container *ngSwitchCase="'amdc_alberta'">
  <app-agreement-template-alberta
    [entityData]="entityData"
    [taxConfig]="taxConfig"
    [studentAccountEntityData]="studentAccountEntityData"
    [studioInformationConfig]="studioInformationConfig"
    [enrollmentForm]="enrollmentForm"
    [isTaxInclusive]="isTaxInclusive"
    [displaySignatures]="displaySignatures"
    [displaySigned]="displaySigned"
    [_enrollmentEntityData]="_enrollmentEntityData">
  </app-agreement-template-alberta>
</ng-container>

<!-- Winnipeg Template -->
<ng-container *ngSwitchCase="'amdc_winnipeg'">
  <app-agreement-template-winnipeg
    [entityData]="entityData"
    [taxConfig]="taxConfig"
    [studentAccountEntityData]="studentAccountEntityData"
    [studioInformationConfig]="studioInformationConfig"
    [enrollmentForm]="enrollmentForm"
    [isTaxInclusive]="isTaxInclusive"
    [displaySignatures]="displaySignatures"
    [displaySigned]="displaySigned"
    [_enrollmentEntityData]="_enrollmentEntityData">
  </app-agreement-template-winnipeg>
</ng-container>

<!-- Sydney/Chatswood Premium Template -->
<ng-container *ngSwitchCase="'amdc_sydney_premium'">
  <app-agreement-template-sydney-premium
    [entityData]="entityData"
    [studentAccountEntityData]="studentAccountEntityData"
    [studioInformationConfig]="studioInformationConfig"
    [enrollmentForm]="enrollmentForm"
    [isTaxInclusive]="isTaxInclusive"
    [displaySignatures]="displaySignatures"
    [displaySigned]="displaySigned"
    [_enrollmentEntityData]="_enrollmentEntityData">
  </app-agreement-template-sydney-premium>
</ng-container>

<!-- Australian Template -->
<ng-container *ngSwitchCase="'amdc_australian'">
  <app-agreement-template-australian
    [entityData]="entityData"
    [studentAccountEntityData]="studentAccountEntityData"
    [studioInformationConfig]="studioInformationConfig"
    [enrollmentForm]="enrollmentForm"
    [isTaxInclusive]="isTaxInclusive"
    [displaySignatures]="displaySignatures"
    [displaySigned]="displaySigned"
    [_enrollmentEntityData]="_enrollmentEntityData">
  </app-agreement-template-australian>
</ng-container>

<!-- US Standard Template (default) -->
<ng-container *ngSwitchDefault>
<div id="enrollment-agreement">
    <div class="page1">

        <div id="enrollment-agreement-new">
            <p class="text-center"><img style="max-width:350px;" src="assets/images/AMDCBlackHorizontalJPG.jpg" /></p>
            <!-- Student Enrollment Agreement Section -->
            <div class="container border p-3 bg-white text-dark">
                <h4 class="fw-bold text-center">STUDENT ENROLLMENT AGREEMENT</h4>
                <div class="d-flex justify-content-between">
                    <div>
                        <p class="mb-1">{{
                            this.studioInformationConfig?.field_studio_address?.[0]?.address_line1
                            }},
                            {{
                            this.studioInformationConfig?.field_studio_address?.[0]?.locality
                            }},
                            {{
                            this.studioInformationConfig?.field_studio_address?.[0]?.administrative_area
                            }}
                            {{
                            this.studioInformationConfig?.field_studio_address?.[0]?.postal_code
                            }}</p>
                        <p class="mb-1">{{
                            this.studioInformationConfig?.field_studio_phone_number?.[0]?.value
                            }}</p>
                        <p class="mb-1">{{
                            this.studioInformationConfig?.field_studio_email?.[0]?.value
                            }}</p>
                    </div>
                    <div class="text-end">
                        <p class="fw-bold mb-1">AGREEMENT DATE: <span
                                class="text-success">{{
                                this.entityData?.['field_sale_date'] | date
                                }}</span></p>
                        <p class="fw-bold">TOTAL FEES: <span
                                class="text-success">{{ calculateTotalTuition()
                                | studioCurrency }}</span></p>
                    </div>
                </div>
            </div>

            <h4>1. PARTIES TO THE AGREEMENT</h4>
            <div class="row mb-3">
                <div class="col-12">
                    <div class="mb-3">
                        <p class="d-flex">
                            <span class="fw-bold me-2">STUDIO OWNER
                                INFORMATION:</span>
                            <span class="flex-grow-1 mx-1 border-bottom"
                                style="min-width: 250px;">{{
                                this.studioInformationConfig?.field_studio_display_name?.[0]?.value
                                }}</span>
                            <span>("us")</span>
                        </p>
                    </div>

                    <div class="mb-3">
                        <p class="d-flex">
                            <span class="fw-bold me-2">STUDIO ADDRESS:</span>
                            <span class="flex-grow-1 mx-1 border-bottom"
                                style="min-width: 250px;">{{
                                this.studioInformationConfig?.field_studio_address?.[0]?.address_line1
                                }},
                                {{
                                this.studioInformationConfig?.field_studio_address?.[0]?.locality
                                }},
                                {{
                                this.studioInformationConfig?.field_studio_address?.[0]?.administrative_area
                                }}
                                {{
                                this.studioInformationConfig?.field_studio_address?.[0]?.postal_code
                                }}</span>
                            <span>("the Studio")</span>
                        </p>
                    </div>

                    <h6 class="fw-bold">Buyer Information:</h6>
                    <div class="border p-2">
                        <table class="table table-borderless mb-0">
                            <tr>
                                <td class="fw-bold"
                                    style="width: 10%">Name:</td>
                                <td style="width: 40%">{{
                                    entityData?.['field_student']?.['title'] ||
                                    'Not specified' }} ("you")</td>
                                <td class="fw-bold" style="width: 15%">Email
                                    Address:</td>
                                <td style="width: 35%">{{
                                    primaryContact?.field_email
                                    || 'Not specified' }}</td>
                            </tr>
                            <tr>
                                <td class="fw-bold">Cell phone#:</td>
                                <td>{{
                                    primaryContact?.field_cell_phone
                                    || 'Not specified' }}</td>
                                <td class="fw-bold">Address:</td>
                                <td>
                                    <ng-container
                                        *ngIf="primaryContact?.field_address">
                                        {{
                                        primaryContact?.field_address?.address_line1
                                        || '' }}
                                        <ng-container
                                            *ngIf="primaryContact?.field_address?.locality">
                                            , {{
                                            primaryContact?.field_address?.locality
                                            }}
                                        </ng-container>
                                        <ng-container
                                            *ngIf="primaryContact?.field_address?.administrative_area">
                                            , {{
                                            primaryContact?.field_address?.administrative_area
                                            }}
                                        </ng-container>
                                        <ng-container
                                            *ngIf="primaryContact?.field_address?.postal_code">
                                            {{
                                            primaryContact?.field_address?.postal_code
                                            }}
                                        </ng-container>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="!primaryContact?.field_address">
                                        Not specified
                                    </ng-container>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <h4>2. SUMMARY OF CHARGES</h4>

            <div class="row mb-3">
                <div
                    class="col-12 d-flex justify-content-between align-items-center">
                    <span class="fw-semibold">Enrollment Type:</span>
                    <span class="d-flex gap-2">
                        <div class="choice-box" [class.is-checked]="enrollmentTypeState.original">
                            <span class="choice-square" aria-hidden="true"></span>
                            <span class="choice-label">Original</span>
                        </div>
                        <div class="choice-box" [class.is-checked]="enrollmentTypeState.extension">
                            <span class="choice-square" aria-hidden="true"></span>
                            <span class="choice-label">Extension</span>
                        </div>
                        <div class="choice-box" [class.is-checked]="enrollmentTypeState.renewal">
                            <span class="choice-square" aria-hidden="true"></span>
                            <span class="choice-label">Renewal</span>
                        </div>
                        <div class="choice-box" [class.is-checked]="enrollmentTypeState.service">
                            <span class="choice-square" aria-hidden="true"></span>
                            <span class="choice-label">Service</span>
                        </div>
                    </span>
                </div>
            </div>

            <div class="row mb-3">
                <div
                    class="col-12 d-flex justify-content-between align-items-center">
                    <span class="fw-semibold">Lesson Type:</span>
                    <span class="d-flex gap-2">
                        <div class="choice-box is-checked">
                            <span class="choice-square" aria-hidden="true"></span>
                            <span class="choice-label">Personal Lessons</span>
                        </div>
                        <div class="choice-box">
                            <span class="choice-square" aria-hidden="true"></span>
                            <span class="choice-label">Class Lessons</span>
                        </div>
                        <div class="choice-box">
                            <span class="choice-square" aria-hidden="true"></span>
                            <span class="choice-label">Practice Lessons</span>
                        </div>
                    </span>
                </div>
            </div>

            <div class="mb-3 d-flex" *ngIf="getPackageName()">
                <span class="fw-semibold me-2">Package:</span>
                <span class="flex-grow-1 border-bottom text-break" style="white-space: normal;">{{
                    getPackageName() }}</span>
            </div>

            <div class="mb-3 d-flex" *ngIf="expirationDate">
                <span class="fw-semibold me-2">Expiration Date:</span>
                <span class="flex-grow-1 border-bottom">{{ expirationDate | date }}</span>
            </div>

            <div class="mb-3 d-flex">
                <span class="fw-semibold me-2">Tuition Per Lesson:</span>
                <span class="flex-grow-1 border-bottom">{{
                    (entityData?.['field_enrollment_lesson_price'] || 0) | studioCurrency }}</span>
            </div>

            <div class="mb-3 d-flex">
                <span class="fw-semibold me-2">Number of Lessons
                    Purchased:</span>
                <span class="flex-grow-1 border-bottom">{{
                    entityData?.['field_enrollment_lesson_count'] }}</span>
            </div>

            <div class="mb-3 d-flex">
                <span class="fw-semibold me-2">Total Tuition/Cost:</span>
                <span class="flex-grow-1 border-bottom">{{
                    getOriginalPackageCost() | studioCurrency }}</span>
            </div>

            <div class="mb-3 d-flex">
                <span class="fw-semibold me-2">Other Services:</span>
                <span class="flex-grow-1 border-bottom text-break" style="white-space: normal;">{{ getNotes() }}</span>
            </div>

            <div class="mb-3 d-flex">
                <span class="fw-semibold me-2">Discount:</span>
                <span class="flex-grow-1 border-bottom">
                    <ng-container
                        *ngIf="this.entityData?.field_discount_type == 'flat'">
                        {{ (entityData?.field_discount || 0) | studioCurrency }}
                    </ng-container>
                    <ng-container
                        *ngIf="this.entityData?.field_discount_type == 'percentage'">
                        {{ (entityData?.field_discount || 0) | number:'1.2-2' }}%
                    </ng-container>
                    <ng-container
                        *ngIf="this.entityData?.field_discount_type != 'percentage' && this.entityData?.field_discount_type != 'flat'">
                        {{ (entityData?.field_discount || 0) | studioCurrency }}
                    </ng-container>
                </span>
            </div>

            <div class="mb-3 d-flex">
                <span class="fw-semibold me-2">{{ getTaxLabel() }}:</span>
                <span class="flex-grow-1 border-bottom">{{
                    (entityData?.field_tax_percentage || 0) | number:'1.0-3' }}%{{ isTaxInclusive ? ' (included)' : '' }}</span>
            </div>

            <div class="mb-3 d-flex">
                <span class="fw-bold me-2">Total Fees Due & Payable <span
                        class="text-primary">By</span> You ("Fees"):</span>
                <span class="flex-grow-1 border-bottom">{{
                    (entityData?.field_enrollment_total_price || 0) | studioCurrency
                    }}{{ isTaxInclusive && entityData?.field_taxes ? ' (includes ' + getTaxLabel() + ' ' + (entityData?.field_taxes | studioCurrency) + ')' : '' }}</span>
            </div>

            <div class="row print-d-none d-none">
                <p class="text-center">
                    <small><a class="cursor-pointer"
                            (click)="requestPrint(true, false)">Click here to view back of agreement (fully included and opened when printed or emailed)</a></small>
                </p>
            </div>

            <div
                *ngIf="enrollmentForm?.get('field_payments_structure')?.value !== 'paid_in_full'">
                <h4>3. Lending Disclosures for Budget Courses or Studio Payment
                    Programs</h4>
                <div class="row mb-3">
                    <div class="col-12">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-6">
                                    <table class="table table-bordered">
                                        <tr>
                                            <td>1. Total Fees under this
                                                agreement...................</td>
                                            <td class="text-end">{{ calculateTotalTuition() |
                                                studioCurrency }}</td>
                                        </tr>
                                        <tr>
                                            <td>2. Outstanding Balance of
                                                Previous Agreement...</td>
                                            <td class="text-end">{{
                                                (entityData?.field_outstanding_balance_pc
                                                ?
                                                entityData?.field_outstanding_balance_pc
                                                : '0') | studioCurrency }}</td>
                                        </tr>
                                        <tr>
                                            <td>3. Unearned Finance
                                                Charge.....................</td>
                                            <td class="text-end">{{
                                                (entityData?.field_unearned_finance_charge
                                                ?
                                                entityData?.field_unearned_finance_charge
                                                : '0') | studioCurrency }}</td>
                                        </tr>
                                        <tr>
                                            <td>4. Previous Balance to be
                                                Refinanced (2-3), if any..</td>
                                            <td class="text-end">{{
                                                (entityData?.field_outstanding_balance_pc
                                                -
                                                (entityData?.field_unearned_finance_charge
                                                || 0)) | studioCurrency }}</td>
                                        </tr>
                                        <tr>
                                            <td>5. Consolidated Cash Price
                                                (1+4).......................</td>
                                            <td class="text-end">{{ (calculateTotalTuition() +
                                                (entityData?.field_outstanding_balance_pc
                                                -
                                                (entityData?.field_unearned_finance_charge
                                                || 0))) | studioCurrency }}</td>
                                        </tr>
                                        <tr>
                                            <td>6. Cash Down
                                                Payment.............................</td>
                                            <td class="text-end">{{
                                                getDownPaymentAmount() | studioCurrency }}</td>
                                        </tr>
                                    </table>

                                    <div class="p-3 mb-2"
                                        style="border: 1px solid #000; background-color: #f2f2f2;">
                                        <strong>AMOUNT FINANCED:</strong>
                                        <div class="d-flex justify-content-between align-items-end">
                                            <span>The amount of credit that is provided to
                                                you or on your
                                                behalf...................................</span>
                                            <span class="text-nowrap ms-2">{{
                                                entityData?.field_enrollment_total_price | studioCurrency
                                                }}</span>
                                        </div>
                                    </div>

                                    <div class="p-3 mb-2"
                                        style="border: 1px solid #000; background-color: #f2f2f2;">
                                        <strong>FINANCE CHARGE:</strong>
                                        <div class="d-flex justify-content-between align-items-end">
                                            <span>The dollar amount the credit will cost
                                                you......</span>
                                            <span class="text-nowrap ms-2">{{
                                                (entityData?.field_finance_charge ?
                                                entityData?.field_finance_charge :
                                                '0') | studioCurrency }}</span>
                                        </div>
                                    </div>

                                    <div class="p-3 mb-2"
                                        style="border: 1px solid #000; background-color: #f2f2f2;">
                                        <strong>TOTAL OF PAYMENTS</strong>
                                        <div class="d-flex justify-content-between align-items-end">
                                            <span>The amount you will have paid after you
                                                have made all payments as
                                                scheduled........................</span>
                                            <span class="text-nowrap ms-2">{{
                                                calculateTotalTuition() |
                                                studioCurrency }}</span>
                                        </div>
                                    </div>

                                    <div class="p-3 mb-2"
                                        style="border: 1px solid #000; background-color: #f2f2f2;">
                                        <strong>TOTAL SALE PRICE</strong>
                                        <div class="d-flex justify-content-between align-items-end">
                                            <span>The total cost of your purchase on
                                                credit including the down payment of {{
                                                getDownPaymentAmount() |
                                                studioCurrency }}...........</span>
                                            <span class="text-nowrap ms-2">{{
                                                calculateTotalTuition() |
                                                studioCurrency }}</span>
                                        </div>
                                    </div>

                                    <div class="p-3 mb-2"
                                        style="border: 1px solid #000; background-color: #f2f2f2;">
                                        <strong>ANNUAL PERCENTAGE
                                            RATE</strong>
                                        <div class="d-flex justify-content-between align-items-end">
                                            <span>The cost of your credit as a yearly
                                                rate............</span>
                                            <span class="text-nowrap ms-2">{{
                                                entityData?.field_finance_apr ?
                                                entityData?.field_finance_apr : '0'
                                                }}%</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <strong>YOUR PAYMENT SCHEDULE WILL BE:</strong>

                                    <!-- Show original summary format when all payments are the same -->
                                    <ng-container *ngIf="areAllPaymentAmountsSame(); else showDetailedPayments">
                                        <table class="table table-bordered mt-2">
                                            <tr>
                                                <th class="text-center">No. of Payments</th>
                                                <th class="text-center">Amount of Payments</th>
                                            <th class="text-center">Payments Due</th>
                                            </tr>
                                            <tr>
                                                <td class="text-center">{{ (entityData?.field_scheduled_payments?.length) || (entityData?.field_scheduled_payments?.['0'] ? 1 : 0) }}</td>
                                                <td class="text-center">{{ getFirstPaymentAmount() | studioCurrency }}</td>
                                                <td class="text-center">{{ getFirstPaymentDate() === 'Not specified' ? 'Not specified' : (getFirstPaymentDate() | date) }}</td>
                                            </tr>
                                        </table>
                                        <p>Payments due as scheduled above, until paid in full.</p>
                                    </ng-container>

                                    <!-- Show detailed format when payments differ -->
                                    <ng-template #showDetailedPayments>
                                        <table class="table table-bordered mt-2">
                                            <tr>
                                                <th class="text-center">Payment #</th>
                                                <th class="text-center">Amount</th>
                                                <th class="text-center">Due Date</th>
                                            </tr>
                                            <ng-container *ngIf="entityData?.field_scheduled_payments?.length; else singlePaymentTemplate">
                                                <tr *ngFor="let payment of entityData?.field_scheduled_payments; let i = index">
                                                    <td class="text-center">{{ i + 1 }}</td>
                                                    <td class="text-center">{{ (payment?.field_payment_amount || payment?.['0']?.field_payment_amount) | studioCurrency }}</td>
                                                    <td class="text-center">{{ (payment?.field_payment_date || payment?.['0']?.field_payment_date) | date }}</td>
                                                </tr>
                                            </ng-container>
                                            <ng-template #singlePaymentTemplate>
                                                <tr *ngIf="entityData?.field_scheduled_payments?.['0']">
                                                    <td class="text-center">1</td>
                                                    <td class="text-center">{{ entityData?.field_scheduled_payments?.['0']?.field_payment_amount | studioCurrency }}</td>
                                                    <td class="text-center">{{ entityData?.field_scheduled_payments?.['0']?.field_payment_date | date }}</td>
                                                </tr>
                                                <tr *ngIf="!entityData?.field_scheduled_payments?.['0']">
                                                    <td class="text-center" colspan="3">No scheduled payments configured</td>
                                                </tr>
                                            </ng-template>
                                        </table>
                                        <p *ngIf="entityData?.field_scheduled_payments?.length > 1">
                                            <small class="text-muted">
                                                Payment amounts and dates as shown above.
                                            </small>
                                        </p>
                                    </ng-template>
                                    <div class="mt-4">

                                        <div class="p-3"
                                            style="border: 1px solid #000; background-color: #f8f9fa;">
                                            <strong>NOTICE TO YOU:</strong> DO
                                            NOT SIGN THIS AGREEMENT BEFORE YOU
                                            READ IT OR IF IT CONTAINS ANY BLANK
                                            SPACES INTENDED FOR YOU. AGREED
                                            TERMS TO THE EXTENT OF THEN
                                            AVAILABLE INFORMATION ARE LEFT
                                            BLANK. YOU ARE ENTITLED TO A COPY OF
                                            THE AGREEMENT AT THE TIME YOU SIGN
                                            IT. KEEP THIS AGREEMENT TO PROTECT
                                            YOUR LEGAL RIGHT.
                                        </div>

                                        <div class="mt-3 payoff-section">
                                            <p class="mb-2 fw-semibold">If you pay off early, you:</p>
                                            <div class="payoff-row">
                                                <div class="payoff-options">
                                                    <div class="choice-box" role="checkbox" [attr.aria-checked]="earlyPaymentPenalty" [class.is-checked]="earlyPaymentPenalty">
                                                        <span class="choice-square" aria-hidden="true"></span>
                                                        <span class="choice-label">May</span>
                                                    </div>
                                                    <div class="choice-box" role="checkbox" [attr.aria-checked]="!earlyPaymentPenalty" [class.is-checked]="!earlyPaymentPenalty">
                                                        <span class="choice-square" aria-hidden="true"></span>
                                                        <span class="choice-label">May not</span>
                                                    </div>
                                                </div>
                                                <div class="payoff-note">have to pay a penalty</div>
                                            </div>
                                            <div class="payoff-row">
                                                <div class="payoff-options">
                                                    <div class="choice-box" role="checkbox" [attr.aria-checked]="earlyPaymentRefund" [class.is-checked]="earlyPaymentRefund">
                                                        <span class="choice-square" aria-hidden="true"></span>
                                                        <span class="choice-label">May</span>
                                                    </div>
                                                    <div class="choice-box" role="checkbox" [attr.aria-checked]="!earlyPaymentRefund" [class.is-checked]="!earlyPaymentRefund">
                                                        <span class="choice-square" aria-hidden="true"></span>
                                                        <span class="choice-label">Will not</span>
                                                    </div>
                                                </div>
                                                <div class="payoff-note">be entitled to a refund or part of the finance charge, under rule of 78, pro-rata or actuarial method, whichever, is applicable in your state.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

        <div class="row">
            <div class="col-6">
                <!-- Studio Information -->
                <div class="text-center" *ngIf="displayBottomStudioInfo">
                    <p>{{
                        this.studioInformationConfig?.field_studio_display_name?.[0]?.value
                        }}</p>
                    <p>
                        {{
                        this.studioInformationConfig?.field_studio_address?.[0]?.address_line1
                        }}
                        {{
                        this.studioInformationConfig?.field_studio_address?.[0]?.locality
                        }}
                        {{
                        this.studioInformationConfig?.field_studio_address?.[0]?.administrative_area
                        }}.
                        {{
                        this.studioInformationConfig?.field_studio_address?.[0]?.postal_code
                        }}
                    </p>
                    <p>Phone: {{
                        this.studioInformationConfig?.field_studio_phone_number?.[0]?.value
                        }}</p>
                    <p>Email: {{
                        this.studioInformationConfig?.field_studio_email?.[0]?.value
                        }}</p>
                    <p>{{
                        this.studioInformationConfig?.field_studio_website?.[0]?.title
                        }}</p>
                </div>
            </div>

            <div class="col-6">
                <div class="row" *ngIf="displaySigned">
                    <p *ngIf="expirationDate" class="fw-bold">Expiration/Refund Date: {{ expirationDate | date }}</p>
                    <p>Signed on: {{ saleDate | date }}</p>

                    <div
                        *ngIf="displaySignatures && this._enrollmentEntityData?.['field_representative_signature']?.[0]?.['url']"
                        class="col-6">
                        <p><strong>Executive Approval:</strong></p>
                        <img class="img-fluid"
                            [src]="this._enrollmentEntityData?.['field_representative_signature'][0]?.['url']" />
                    </div>
                    <div
                        *ngIf="displaySignatures && this._enrollmentEntityData?.['field_signature']?.[0]?.['url']"
                        class="col-6">
                        <p><strong>Student Signature:</strong></p>
                        <img class="img-fluid"
                            [src]="this._enrollmentEntityData?.['field_signature']?.[0]?.['url']" />
                    </div>
                    <div
                        *ngIf="displaySignatures && this._enrollmentEntityData?.['field_parent_guardian_signature']?.[0]?.['url']"
                        class="col-12 mt-3">
                        <p><strong>Parent/Guardian Signature:</strong></p>
                        <img class="img-fluid"
                            [src]="this._enrollmentEntityData?.['field_parent_guardian_signature'][0]?.['url']" />
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3"></div>
    </div>
</div>
</ng-container>

</ng-container>
</ng-container>
